import {
  AnimatedAnnotation,
  AnnotationLabel,
  AnnotationLineSubject,
} from '@visx/xychart';
import PropTypes from 'prop-types';
import * as React from 'react';

export const DEFAULT_HORIZONTAL_REFERENCE_LINE_COLOR = '#f43838';
export const DEFAULT_HORIZONTAL_REFERENCE_LINE_REFERENCE = 1;
export const DEFAULT_HV_LINE_STROKE_DASHARRAY = '4 4';
const DEFAULT_STROKE_WIDTH = 1;

const SparklinesChartHorizontalLine = ({
  dataKey,
  labelX,
  labelY,
  xAccessor,
  yAccessor,
  datum,
  hideLabel,
  stroke,
  strokeWidth,
  strokeDasharray,
  label,
}) => (
  <AnimatedAnnotation
    dataKey={dataKey}
    datum={datum}
    xAccessor={xAccessor}
    yAccessor={yAccessor}
  >
    {!hideLabel ? (
      <AnnotationLabel
        titleProps={{fill: stroke}}
        title={label}
        width={0}
        // position of label is absolutly positioned, this solution is far from an ideal
        x={labelX}
        y={labelY}
      />
    ) : null}
    <AnnotationLineSubject
      orientation={'horizontal'}
      strokeWidth={strokeWidth}
      stroke={stroke}
      strokeDasharray={strokeDasharray}
    />
  </AnimatedAnnotation>
);

SparklinesChartHorizontalLine.displayName = 'SparklinesChartHorizontalLine';

SparklinesChartHorizontalLine.propTypes = {
  dataKey: PropTypes.string.isRequired,
  datum: PropTypes.objectOf(PropTypes.any).isRequired,
  xAccessor: PropTypes.func.isRequired,
  yAccessor: PropTypes.func.isRequired,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  labelX: PropTypes.number,
  labelY: PropTypes.number,
  stroke: PropTypes.string,
  strokeDasharray: PropTypes.string,
  strokeWidth: PropTypes.number,
};

SparklinesChartHorizontalLine.defaultProps = {
  hideLabel: false,
  label: '',
  labelX: 0,
  labelY: 0,
  stroke: DEFAULT_HORIZONTAL_REFERENCE_LINE_COLOR,
  strokeDasharray: DEFAULT_HV_LINE_STROKE_DASHARRAY,
  strokeWidth: DEFAULT_STROKE_WIDTH,
};

export default SparklinesChartHorizontalLine;
